<template>
  <div class="setPassPage">
    
    <Back/>
    <Login :loginType="2"/>


  </div>
</template>

<script>

import Login from '@/components/Login/index.vue'
import Back from '@/components/NavBar/back.vue'
export default {
  name: 'SetPass',
  data(){
    return {
      loginType:0,

      
    }
  },
  components: {
    Back,
    Login,
  },
  methods:{
 
  }
}
</script>

<style lang="scss" scoped>
  .setPassPage{
    width: 100%;
    height: 100%;
  }
  
</style>
